import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "onboarding-text-container px-4" }
const _hoisted_3 = { class: "onboarding-text-column" }
const _hoisted_4 = { class: "onboarding-columns-container px-4" }
const _hoisted_5 = { class: "onboarding-column" }
const _hoisted_6 = { class: "onboarding-column" }
const _hoisted_7 = { class: "onboarding-column" }
const _hoisted_8 = { class: "onboarding-terms-container px-4" }
const _hoisted_9 = { class: "modal-footer" }

import { ref, watch } from "vue";

interface Props {
  isOpen: boolean;
  title?: string;
  primaryButtonLabel?: string;
  secondaryButtonLabel?: string;
  loading?: boolean;
  termsUrl?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingModal',
  props: {
    isOpen: { type: Boolean },
    title: { default: "Seleção Inicial" },
    primaryButtonLabel: { default: "Continuar" },
    secondaryButtonLabel: { default: "Continuar" },
    loading: { type: Boolean, default: false },
    termsUrl: { default: "https://feegow.com/termos-e-condicoes" }
  },
  emits: ["close", "primary-button-click", "secondary-button-click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = ref(props.isOpen);

watch(
  () => props.isOpen,
  (newValue) => {
    isOpen.value = newValue;
  },
);

watch(isOpen, (newValue) => {
  if (!newValue) {
    emit("close");
  }
});

const onClose = () => {
  isOpen.value = false;
};

const onPrimaryButtonClick = () => {
  emit("primary-button-click");
  localStorage.setItem("aiAssistant.onboardingModalShown", "true");
};

const onSecondaryButtonClick = () => {
  emit("secondary-button-click");
  localStorage.setItem("aiAssistant.onboardingModalShownDate", new Date().toISOString());
};

return (_ctx: any,_cache: any) => {
  const _component_w_text = _resolveComponent("w-text")!
  const _component_w_icon = _resolveComponent("w-icon")!
  const _component_w_link = _resolveComponent("w-link")!
  const _component_w_button = _resolveComponent("w-button")!
  const _component_w_modal = _resolveComponent("w-modal")!

  return (_openBlock(), _createBlock(_component_w_modal, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    id: "onboarding-modal",
    size: "medium",
    class: "onboarding-modal",
    title: __props.title,
    "close-on-click-outside": false,
    onClose: onClose
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "body", {}, () => [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "onboarding-image-container" }, [
            _createElementVNode("img", {
              src: "https://cdn.feegow.com/noa/onboarding.png",
              alt: "Logo",
              class: "onboarding-image"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_w_text, { type: "body" }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Conheça o Noa Notes e deixe-o fazer anotações durante suas consultas e criar resumos estruturados para você.", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_w_icon, {
                name: "clock-filled",
                size: "large",
                color: "accent"
              }),
              _createVNode(_component_w_text, { type: "body" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Reduza o tempo gasto com anotações e dedique-o aos seus pacientes.", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "onboarding-column-divider" }, null, -1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_w_icon, {
                name: "pen",
                size: "large",
                color: "accent"
              }),
              _createVNode(_component_w_text, { type: "body" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Mantenha o controle. Revise e edite o resumo a qualquer momento.", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "onboarding-column-divider" }, null, -1)),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_w_icon, {
                name: "lock",
                size: "large",
                color: "accent"
              }),
              _createVNode(_component_w_text, { type: "body" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Seus dados estão protegidos com os mais altos padrões de criptografia.", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_w_text, {
              type: "body",
              class: "onboarding-terms-text"
            }, {
              default: _withCtx(() => [
                _cache[8] || (_cache[8] = _createTextVNode(" Ao iniciar a transcrição, você concorda com nossos ", -1)),
                _createVNode(_component_w_link, {
                  target: "_blank",
                  href: __props.termsUrl
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("Termos e Condições", -1)
                  ]))]),
                  _: 1
                }, 8, ["href"]),
                _cache[9] || (_cache[9] = _createTextVNode(". Peça permissão ao seu paciente antes de começar a transcrever o áudio. ", -1))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _renderSlot(_ctx.$slots, "footer", {}, () => [
          _createVNode(_component_w_button, {
            label: __props.secondaryButtonLabel,
            variant: "secondary",
            onClick: onSecondaryButtonClick,
            loading: __props.loading
          }, null, 8, ["label", "loading"]),
          _createVNode(_component_w_button, {
            label: __props.primaryButtonLabel,
            variant: "primary",
            onClick: onPrimaryButtonClick,
            loading: __props.loading
          }, null, 8, ["label", "loading"])
        ])
      ])
    ]),
    _: 3
  }, 8, ["modelValue", "title"]))
}
}

})